<template>
  <span>
    <router-link :to="{ name: 'tags', params: { tag_name: tag.name } }" class="text-light">
      {{tag.name}}
    </router-link>
  </span>
</template>

<script>
import Tag from "components/Tag";

export default {
  components: {
    Tag
  },
  props: {
    tag: {
      type: Object
    }
  }
}
</script>
